<template>
  <v-container fluid grid-list-md style="padding: 30px">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select outlined dense v-model="eventoId" :items="itensOrdenados" item-text="nome" item-value="id"
          label="Selecione o Evento" @input="carregaInscritos()" color="#0D47A1"></v-select>
      </v-col>
    </v-row>
    <v-data-table :search="search" v-if="!addUser" :headers="headers" :items="inscritos" sort-by="nome"
      class="elevation-1" style="border-radius: 10px">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px">
          <v-toolbar-title class="textoUser">INSCRITOS</v-toolbar-title>
          <v-spacer></v-spacer>
          
          <v-menu
            v-model="showFilterMenu"
            :close-on-content-click="false"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#7B1FA2"
                dark
                v-bind="attrs"
                v-on="on"
                class="mr-2"
              >
                <v-icon left>filter_list</v-icon>
                Filtrar por Data
              </v-btn>
            </template>
            
            <v-card min-width="350px" class="pa-3">
              <v-card-title class="pb-0">Filtrar por data</v-card-title>
              
              <v-radio-group v-model="filtroTipo" row class="mt-2">
                <v-radio value="cadastro" label="Data de Cadastro"></v-radio>
                <v-radio value="pagamento" label="Data de Pagamento"></v-radio>
              </v-radio-group>
              
              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="menuDataInicio"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataInicio"
                        label="Data Inicial"
                        outlined
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="mt-3"
                        prepend-icon="event"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataInicioRaw"
                      no-title
                      @input="menuDataInicio = false"
                      locale="pt-BR"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="menuDataFim"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFim"
                        label="Data Final"
                        outlined
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="mt-3"
                        prepend-icon="event"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataFimRaw"
                      no-title
                      @input="menuDataFim = false"
                      locale="pt-BR"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="#D32F2F" @click="limparFiltroData">Limpar</v-btn>
                <v-btn color="#7B1FA2" dark @click="aplicarFiltroData">Aplicar</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          
          <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="editItem(item)" v-if="user.tipo != 'CHECKIN'" v-bind="attrs" v-on="on">
              edit
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="enviarNotificacao(item)" v-if="user.tipo != 'CHECKIN'"
              :disabled="item.statusPagamento != 'PAGO'" v-bind="attrs" v-on="on">
              send
            </v-icon>
          </template>
          <span>Enviar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="enviarCertificado(item)" v-if="user.tipo != 'CHECKIN'" :disabled="!item.urlCertificado"
              v-bind="attrs" v-on="on">
              mdi-certificate
            </v-icon>
          </template>
          <span>Gerar Certificado</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="openDialog(item)" v-bind="attrs" v-on="on"> check_circle </v-icon>
          </template>
          <span>Check-in</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="deleteItem(item)" v-if="user.tipo != 'CHECKIN'" v-bind="attrs" v-on="on">
              delete
            </v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>

        <v-icon v-if="
          eventoId == '61ec94340cf286040f6c78ad' ||
          eventoId == '61ec9a360cf286040f6c78ae'
        " @click="printItem(item)">
          print
        </v-icon>
      </template>
      <template v-slot:[`item.ultimaVisualizacao`]="{ item }">
        <p v-if="item.ultimaVisualizacao" style="margin: 0px">
          {{ transformaData(item.ultimaVisualizacao, "DD/MM/YYYY") }} às
          {{ transformaData(item.ultimaVisualizacao, "HH:mm:ss") }}
        </p>
      </template>
      <template v-slot:[`item.possuiAlergia`]="{ item }">
        <p style="margin: 0px">{{ item.possuiAlergia ? "Sim" : "Não" }}</p>
      </template>
      <template v-slot:[`item.possuiRestricaoAlimentar`]="{ item }">
        <p style="margin: 0px">
          {{ item.possuiRestricaoAlimentar ? "Sim" : "Não" }}
        </p>
      </template>
      <template v-slot:[`item.idade`]="{ item }">
        <p style="margin: 0px" v-if="!item.idade">{{ calculateAge(item.dataNascimento) + ' anos' }}</p>
        <p style="margin: 0px" v-else>{{ item.idade + ' anos' }}</p>
      </template>
      <template v-slot:[`item.tomaMedicamento`]="{ item }">
        <p style="margin: 0px">{{ item.tomaMedicamento ? "Sim" : "Não" }}</p>
      </template>
      <template v-slot:[`item.codigoTransacao`]="{ item }">
        <td><a :href="item.codigoTransacao" target="_blank">{{ item.codigoTransacao }}</a></td>
      </template>
      <template v-slot:[`item.valorPago`]="{ item }">
        <p style="margin: 0px" v-if="item.valorPago">{{ item.valorPago.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL"
        }) }}</p>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum cadastro
              encontrado</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{ search }}"
              não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
    <br />
    <v-card-actions>
      <!-- <v-btn color="#7B1FA2" @click="print" style="color: #ffffff">Imprimir</v-btn> -->
      <!-- <v-btn color="#7B1FA2" @click="carregaDados" style="color: #ffffff">Recarregar</v-btn> -->

      <v-btn dark color="#7B1FA2" @click="exportarParaCSV">
        <v-icon left size="25" color="white">cloud_download</v-icon>
        Exportar Relatório
      </v-btn>

    </v-card-actions>
    <v-dialog v-model="dialog" max-width="350px">
      <v-card style="border-radius: 10px">
        <v-card-title style="justify-content: center; padding: 8px">
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 2px">
                <p class="texto" style="color: #8e24aa">
                  Realizar checkin manual
                </p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px">
                <p class="texto">Nome: {{ nome }}</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px">
                <p class="texto">Código: {{ checkin.cod_incricao }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -32px; padding: 20px 5px 0px">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs6 sm6 lg6>
                <v-btn :loading="loading" dark depressed block color="#4A148C" style="border-radius: 7px" large
                  @click="realizaCheckin">Validar</v-btn>
              </v-flex>
              <v-flex xs6 sm6 lg6>
                <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px" large
                  @click="close">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editarInscricao" max-width="1000px">
      <v-card style="border-radius: 10px">
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <p style="margin-bottom: 5px">Informações da inscrição</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="8" lg="8">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2" dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4">
                <v-text-field v-model="editedItem.cpf" outlined label="CPF" color="#7B1FA2" dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4">
                <v-text-field v-model="editedItem.email" outlined label="E-mail" color="#7B1FA2" dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4">
                <v-text-field v-model="editedItem.telefone" outlined label="Telefone" color="#7B1FA2" dense
                  v-mask="'(##) #####-####'" hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4">
                <v-select v-model="editedItem.sexo" outlined label="Sexo" color="#7B1FA2" :items="sexos" hide-details
                  item-text="text" item-value="value" dense></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.cargo">
                <v-text-field v-model="editedItem.cargo" outlined label="E-mail" color="#7B1FA2" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.empresa">
                <v-text-field v-model="editedItem.empresa" outlined label="Empresa" color="#7B1FA2"
                  dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.nomeCracha">
                <v-text-field v-model="editedItem.nomeCracha" outlined label="Nome Crachá" color="#7B1FA2"
                  dense></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="4" lg="4" v-if="editedItem.tipo">
                <v-select v-model="editedItem.tipo" outlined label="Tipo de Inscrição" color="#7B1FA2" :items="tipos"
                  hide-details item-text="text" item-value="value" dense></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4">
                <v-text-field v-model="editedItem.infoVacina" outlined label="Informação Vacinal" color="#7B1FA2" dense
                  disabled hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4">
                <v-text-field v-model="editedItem.numero" outlined label="Nº Identificação" color="#7B1FA2"
                  dense></v-text-field>
              </v-col> -->
              <!-- <v-col cols="12" sm="12" md="4" lg="4">
                <v-select v-model="editedItem.participantes" outlined label="Quantidade" color="#7B1FA2"
                  :items="quantidade" hide-details item-text="text" item-value="value" dense></v-select>
              </v-col> -->
              <v-col cols="12" sm="12" md="12" lg="12" v-if="
                editedItem.statusPagamento ||
                editedItem.formOfPayment ||
                editedItem.valorPago ||
                editedItem.codigoTransacao
              ">
                <p style="margin-bottom: 5px">Informações do pagamento</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-select v-model="editedItem.statusPagamento" outlined label="Status de Pagamento" color="#7B1FA2"
                  :items="statusPagamento" hide-details item-text="text" item-value="value" dense></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.formOfPayment != ''">
                <v-select v-model="editedItem.formOfPayment" outlined label="Forma de Pagamento" color="#7B1FA2"
                  :items="formaPagamento" hide-details item-text="text" item-value="value" dense></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-text-field v-model="editedItem.valorPago" prefix="R$" outlined label="Valor Pago" color="#7B1FA2"
                  dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" v-if="editedItem.codigoTransacao != ''">
                <v-text-field v-model="editedItem.codigoTransacao" outlined label="Código de Transação" color="#7B1FA2"
                  dense disabled hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" v-if="arquivoComprovanteVacinal != ''">
                <v-card elevation="6">
                  <v-img v-if="arquivoComprovanteVacinal != ''" :src="arquivoComprovanteVacinal" height="130px"></v-img>
                  <v-alert v-if="arquivoComprovanteVacinal == ''" dark dense text outlined :value="true" color="warning"
                    icon="info" prominent>Nenhum anexo enviado</v-alert>
                  <v-card-title style="font-size: 17px">COMPROVANTE VACINAL</v-card-title>
                  <v-card-actions>
                    <v-btn v-if="arquivoComprovanteReciclagem != ''" color="#7B1FA2"
                      @click="visualizaImagem(arquivoComprovanteVacinal)" text>Visualizar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#BA68C8" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-md v-show="false">
      <v-layout row wrap id="printInscricao" style="padding: 15px">
        <v-flex xs12 sm12 lg12>
          <img src="../assets/liberdade.png" width="180px" />
        </v-flex>
        <v-flex xs12 sm12 lg12>
          <br />
          <p style="font-size: 18px; text-align: center">
            <b>CADASTRO DO PARTICIPANTE - ED2022 4, 5 e 6 MARÇO 2022</b>
          </p>
          <br />
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME</b></p>
          <p style="padding-left: 3px">{{ impressao.nome }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>CPF</b></p>
          <p style="padding-left: 3px">{{ impressao.cpf }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>IDENTIFICAÇÃO</b></p>
          <p style="padding-left: 3px">{{ impressao.numero }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>DATA DE NASCIMENTO</b></p>
          <p style="padding-left: 3px">{{ impressao.dataNascimento }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>SEXO</b></p>
          <p style="padding-left: 3px">{{ impressao.sexo }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefone }}</p>
        </v-flex>
        <v-flex xs5 sm5 lg5 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>PREFERE SER CHAMADO(A) POR</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeSocial }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TIPO DE INSCRIÇÃO</b></p>
          <p style="padding-left: 3px">{{ impressao.tipo }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TAMANHO DA CAMISA</b></p>
          <p style="padding-left: 3px">{{ impressao.tamanhoCamisa }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <p>Informações da célula</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>CÉLULA</b></p>
          <p style="padding-left: 3px">{{ impressao.celula }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>LÍDER DA CÉLULA</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeLider }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE DO LÍDER</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneLider }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <p>Informações de contato dos pais</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME DA MÃE</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeMae }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneMae }}</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME DO PAI</b></p>
          <p style="padding-left: 3px">{{ impressao.nomePai }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefonePai }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <p>Informações dos três amigos</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME AMIGO(A) 1</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeAmigo1 }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneAmigo1 }}</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME AMIGO(A) 2</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeAmigo2 }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneAmigo2 }}</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME AMIGO(A) 3</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeAmigo3 }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneAmigo3 }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12>
          <br />
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>USA MEDICAMENTO CONTÍNUO?</b></p>
          <p style="padding-left: 3px" v-if="impressao.usaMedicamento == true">
            SIM
          </p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>MEDICAMENTO UTILIZADO</b></p>
          <p style="padding-left: 3px">{{ impressao.medicamento }}</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>ALÉRGICO A ALGUMA MEDICAÇÃO</b></p>
          <p style="padding-left: 3px" v-if="impressao.possuiAlergia == true">
            SIM
          </p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>ALERGIA</b></p>
          <p style="padding-left: 3px">{{ impressao.alergia }}</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>POSSUI RESTRIÇÃO ALIMENTAR</b></p>
          <p style="padding-left: 3px" v-if="impressao.restricaoAlimentar == true">
            SIM
          </p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>RESTRIÇÃO</b></p>
          <p style="padding-left: 3px">{{ impressao.restricoes }}</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NECESSITA ATENDIMENTO ESPECIAL</b></p>
          <p style="padding-left: 3px" v-if="impressao.atendimentoEspecial == true">
            SIM
          </p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NECESSIDADE</b></p>
          <p style="padding-left: 3px">{{ impressao.necessidades }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="text-align: center">
          <br />
          <img src="../assets/logoAIPassIntelite-preto.png" width="230px" />
        </v-flex>
      </v-layout>

      <v-layout row wrap id="printEquipe" style="padding: 15px">
        <v-flex xs12 sm12 lg12>
          <img src="../assets/liberdade.png" width="180px" />
        </v-flex>
        <v-flex xs12 sm12 lg12>
          <br />
          <p style="font-size: 18px; text-align: center">
            <b>CADASTRO EQUIPE - ED2022 4, 5 e 6 MARÇO 2022</b>
          </p>
          <br />
        </v-flex>
        <v-flex xs6 sm6 lg6 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME</b></p>
          <p style="padding-left: 3px">{{ impressao.nome }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>CPF</b></p>
          <p style="padding-left: 3px">{{ impressao.cpf }}</p>
        </v-flex>
        <v-flex xs3 sm3 lg3 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>IDENTIFICAÇÃO</b></p>
          <p style="padding-left: 3px">{{ impressao.numero }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>DATA DE NASCIMENTO</b></p>
          <p style="padding-left: 3px">{{ impressao.dataNascimento }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>SEXO</b></p>
          <p style="padding-left: 3px">{{ impressao.sexo }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE</b></p>
          <p style="padding-left: 3px">{{ impressao.telefone }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <p>
            Informações da célula e contato do líder ou contato do supervisor da
            célula
          </p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>CÉLULA</b></p>
          <p style="padding-left: 3px">{{ impressao.celula }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>LÍDER DA CÉLULA</b></p>
          <p style="padding-left: 3px">{{ impressao.nomeLider }}</p>
        </v-flex>
        <v-flex xs4 sm4 lg4 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>TELEFONE DO LÍDER</b></p>
          <p style="padding-left: 3px">{{ impressao.telefoneLider }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="margin-top: 10px">
          <br />
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px">
            <b>FEZ ENCONTRO COM DEUS NA LIBERDADE?</b>
          </p>
          <p style="padding-left: 3px" v-if="impressao.realizouEncontro == true">
            SIM
          </p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px">
            <b>POSSUI ALERGIA A AR CONDICIONADO</b>
          </p>
          <p style="padding-left: 3px" v-if="impressao.alergiaAr == true">
            SIM
          </p>
          <p style="padding-left: 3px" v-else>NÃO</p>
        </v-flex>
        <v-flex xs8 sm8 lg8 style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px">
          <p style="padding-left: 3px"><b>NOME PARA O CRACHÁ</b></p>
          <p style="padding-left: 3px">{{ impressao.crachaNome }}</p>
        </v-flex>
        <v-flex xs12 sm12 lg12 style="text-align: center">
          <br />
          <img src="../assets/logoAIPassIntelite-preto.png" width="230px" />
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialogoNotificacao" max-width="400px" persistent>
      <v-card>
        <v-card-title>Como deseja enviar a notificação?</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-container class="pa-0">
            <v-row>
              <v-col cols="12">
                <v-btn block color="green" dark @click="enviaNotificacao('WHATSAPP')">
                  <v-icon left>mdi-whatsapp</v-icon>Enviar por WhatsApp
                </v-btn>
              </v-col>
              <!-- <v-col cols="12">
              <v-btn block color="primary" dark @click="enviaNotificacao('SMS')">
                <v-icon left>mdi-message-processing</v-icon>Enviar por SMS
              </v-btn>
            </v-col> -->
              <v-col cols="12">
                <v-btn block color="#560ea8" dark @click="enviaNotificacao('EMAIL')">
                  <v-icon left>mdi-email</v-icon>Enviar por E-mail
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text dark depressed color="#D32F2F" @click="dialogoNotificacao = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
    <div v-show="true">
      <Inscricoes ref="inscricoes"></Inscricoes>
    </div>
  </v-container>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { baseApiUrl } from "@/global";
import Snackbar from "../componentes/snackbar.vue";
import Inscricoes from "../componentes/inscricoes.vue";
import moment from "moment";
import axios from "axios";
import PH from "print-html-element";
import { mapState } from "vuex";
export default {
  components: {
    Snackbar,
    Loading,
    Inscricoes,
  },
  data: () => ({
    editarInscricao: false,
    eventoId: "",
    eventoIdAtual: "",
    dadosEvento: "",
    fullPage: true,
    isLoading: false,
    loading: false,
    search: "",
    nome: "",
    addUser: false,
    dialog: false,
    checkin: {
      cod_incricao: "",
      tipo: "",
      eventoId: "",
      empresaId: "",
      userValidatorId: "",
    },
    quantidade: [],
    statusPagamento: ["CANCELADO", "ESTORNADO", "PAGO", "PENDENTE"],
    sexos: ["MASCULINO", "FEMININO"],
    tipos: ["MEMBRO", "VISITANTE"],
    formaPagamento: [
      { value: "BOLETO", text: "BOLETO" },
      { value: "CARTAO", text: "CARTÃO" },
      { value: "CORTESIA", text: "CORTESIA" },
      { value: "EM MAOS", text: "EM MÃOS" },
      { value: "PIX", text: "PIX" },
    ],
    headers: [
      { text: "Código", value: "cod_incricao" },
      { text: "Nome", align: "start", value: "nome", width: "200px" },
      { text: "CPF", value: "cpf" },
      { text: "Telefone", value: "telefone" },
      { text: "Ações", value: "action", sortable: true },
    ],
    headersPadrao: [
      { text: "Código", value: "cod_incricao" },
      { text: "Nome", align: "start", value: "nome", width: "200px" },
      { text: "CPF", value: "cpf" },
      { text: "Telefone", value: "telefone" },
      { text: "Ações", value: "action", sortable: true },
    ],
    editedIndex: -1,
    editedItem: {
      nome: "",
      cpf: "",
      email: "",
      id: "",
      statusPagamento: "",
      sexo: "",
      telefone: "",
      cargo: "",
      empresa: "",
      nomeCracha: "",
      tipo: "",
      celula: "",
      infoVacina: "",
      formOfPayment: "",
      valorPago: "",
      codigoTransacao: "",
      numero: "",
      participantes: "",
    },
    arquivoComprovanteVacinal: "",
    eventos: [],
    inscritos: [],
    impressao: [],
    dialogoNotificacao: false,
    inscricaoId: "",
    listaExportacao: [],
    labelsExportacao: {
      nome: 'Nome Completo',
      cod_incricao: 'Código de Inscrição',
      email: 'E-mail',
      telefone: 'Telefone',
      cpf: 'CPF',
      sexo: 'Sexo',
      statusPagamento: 'Status do Pagamento',
      formOfPayment: 'Forma de Pagamento',
      valorPago: 'Valor Pago (R$)',
      dataHora: 'Data de Inscrição',
      dataHoraPagamento: 'Data do Pagamento',
      checkin: 'Check-in',
      lote: 'Lote',
      tamanhoCamisa: 'Tamanho da Camisa',
      setor: 'Setor',
      cargo: 'Cargo',
      empresaNome: 'Empresa',
      nomeCracha: 'Nome no Crachá',
      participantes: 'Participantes',
      divulgador: 'Divulgador',
      validador: 'Validador Check-in',
      composicao: 'Composição de Ingressos',
      vagas: 'Vagas',
    },
    metaExportacao: {
      sheetName: 'Inscritos',
      fileName: 'Lista de Inscritos',
      author: 'Sistema de Inscrições'
    },
    showFilterMenu: false,
    filtroTipo: 'cadastro',
    filtroAtivo: false,
    dataInicioRaw: null,
    dataFimRaw: null,
    dataInicio: null,
    dataFim: null,
    menuDataInicio: false,
    menuDataFim: false,
    inscritosSemFiltroData: [], // Guarda a lista completa para restaurar quando remover filtro
  }),

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,
    user: (state) => state.userObj,
    companyobj: (state) => state.companyObj,
    formTitle() {
      return this.editedIndex === -1
        ? "ADICIONAR INSCRIÇÃO"
        : "EDITAR INSCRIÇÃO";
    },
    itensOrdenados() {
      return this.eventos.slice().sort((a, b) => {
        // Se ambos não têm 'ordenacao', mantêm a ordem
        if (a.ordenacao == null && b.ordenacao == null) {
          return 0;
        }

        // Se 'a' não tem 'ordenacao', joga ele para o fim
        if (a.ordenacao == null) {
          return 1;
        }

        // Se 'b' não tem 'ordenacao', joga ele para o fim
        if (b.ordenacao == null) {
          return -1;
        }

        // Se ambos têm 'ordenacao', ordena normalmente
        return a.ordenacao - b.ordenacao;
      });
    }
  }),

  mounted() {
    this.carregaDados();
  },

  watch: {
    dataInicioRaw(novaData) {
      if (novaData) {
        this.dataInicio = this.formatDateBrz(novaData);
      }
    },
    dataFimRaw(novaData) {
      if (novaData) {
        this.dataFim = this.formatDateBrz(novaData);
      }
    }
  },

  methods: {
    async printItem(item) {
      this.isLoading = true;
      try {
        await axios
          .get(
            `${baseApiUrl}inscricoes/${item.id
            }?access_token=${sessionStorage.getItem("accToken")}`
          )
          .then((response) => {
            if (response.data) {
              this.impressao = Object.assign({}, response.data);
              setTimeout(() => {
                if (this.eventoId == "61ec94340cf286040f6c78ad") {
                  PH.printElement(document.getElementById("printInscricao"));
                } else if (this.eventoId == "61ec9a360cf286040f6c78ae") {
                  PH.printElement(document.getElementById("printEquipe"));
                }
                this.isLoading = false;
              }, 50);
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Problema ao imprimir. Tente novamente",
          "DESCULPE"
        );
      }
    },

    async carregaDados() {
      this.isLoading = true;
      await axios
        .get(
          `${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id
          }"}]}}&access_token=${sessionStorage.getItem("accToken")}`
        )
        .then((res) => {
          if (res.data != "") {
            if (res.data.cabecalho) {
              this.headers = res.data.cabecalho
            }

            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                this.eventos.push(res.data[key])
              }
            }

            this.eventos = this.eventos.sort(this.compare);
            if (this.eventos[0].ordenacao == null) {
              this.eventoId = this.eventos[0].id;
            } else {
              this.eventoId = this.itensOrdenados[0].id;
            }
            if (this.eventoIdAtual != "") this.eventoId = this.eventoIdAtual;
          } else this.isLoading = false;
        });
      this.quantidade = [];
      for (let i = 0; i < 51; i++) {
        if (i > 0) {
          this.quantidade.push(i);
        }
      }
      await this.carregaInscritos();
    },

    preparaImpressao(array) {
      var pr = this;
      pr.$refs.inscricoes.preparaImpressao(array);
    },

    print() {
      var vm = this;
      vm.$refs.inscricoes.print();
    },

    async save() {
      this.isLoading = true;
      if (this.editedIndex != -1) {
        this.editedItem.nome = this.editedItem.nome;
        this.editedItem.cpf = this.editedItem.cpf;
        this.editedItem.email = this.editedItem.email.trim();
        this.editedItem.statusPagamento = this.editedItem.statusPagamento;
        await axios
          .patch(
            `${baseApiUrl}inscricoes/${this.editedItem.id
            }?access_token=${sessionStorage.getItem("accToken")}`,
            this.editedItem
          )
          .then((res) => {
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack(
                "#0288D1",
                "Operação realizada com sucesso!",
                "INFORMAÇÃO"
              );
              this.carregaDados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Erro ao realizar operação, tente novamente",
              "ERRO"
            );
          });
      } else {
        this.editedItem.empresaId = this.companyobj.id;
        await axios
          .post(
            `${baseApiUrl}Eventos/replaceOrCreate?access_token=${sessionStorage.getItem(
              "accToken"
            )}`,
            this.editedItem
          )
          .then((res) => {
            this.id_evento = res.data.id;
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack(
                "#0288D1",
                "Evento cadastrado com sucesso!",
                "INFORMAÇÃO"
              );
              this.carregaDados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Erro ao cadastrar evento, tente novamente",
              "ERRO"
            );
          });
      }
      this.close();
    },

    calculateAge(dataNasc) {
      let dataAtual = new Date();
      let anoAtual = dataAtual.getFullYear();
      let anoNascParts = dataNasc.split("/");
      let diaNasc = anoNascParts[0];
      let mesNasc = anoNascParts[1];
      let anoNasc = anoNascParts[2];
      let idade = anoAtual - anoNasc;
      let mesAtual = dataAtual.getMonth() + 1;
      // Caso mês atual for menor que o de nascimento, não fez aniversário ainda;
      if (mesAtual < mesNasc) {
        idade--;
      } else {
        // Estando no mês do nascimento, verifica o dia
        if (mesAtual == mesNasc) {
          if (new Date().getDate() < diaNasc) {
            // Caso a data atual for menor que o dia de nascimento, ainda não fez aniversário
            idade--;
          }
        }
      }
      return idade;
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = moment(
        this.formatDateHora(a.fim),
        "DD/MM/YYYY HH:mm:ss",
        true
      ).format();
      const dataB = moment(
        this.formatDateHora(b.fim),
        "DD/MM/YYYY HH:mm:ss",
        true
      ).format();

      let comparison = 0;
      if (dataB >= dataA) comparison = 1;
      else if (dataB < dataA) comparison = -1;
      return comparison;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateHour(data_hora) {
      let data = data_hora.substr(0, 10).split("-");
      data = data[2] + "/" + data[1] + "/" + data[0];
      let hora = data_hora.substr(11, 8);

      return data + " " + hora;
    },

    formatDateBrz(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDatePadrao(date) {
      if (!date) return null;

      const [day, month, year] = date.substr(0, 10).split("/");
      return `${year}-${month}-${day}` + " " + date.substr(11, 6);
    },

    formatDateHora(date) {
      if (!date) return null;

      const [year, month, day] = date.substr(0, 10).split("-");
      return `${day}/${month}/${year}` + " " + date.substr(11, 8);
    },

    async carregaInscritos() {
      let url;

      if (this.companyobj.nome.includes("Perfumadas")) {
        url =
          baseApiUrl +
          'inscricoes?filter={"where":{"and":[{"eventoId":"' +
          this.eventoId +
          '"},{"tipo":"VIRTUAL"}]}, "include":["userValidatorCheckin","divulgador"]}&access_token=' +
          sessionStorage.getItem("accToken");
      } else {
        url =
          baseApiUrl +
          'inscricoes?filter={"where":{"and":[{"eventoId":"' +
          this.eventoId +
          '"}]}, "include":["userValidatorCheckin","divulgador"]}&access_token=' +
          sessionStorage.getItem("accToken");
      }

      let eventoSelecionado = this.eventos.filter(evento => evento.id === this.eventoId)
      if (eventoSelecionado[0].cabecalho) {
        this.headers = eventoSelecionado[0].cabecalho
      } else {
        this.headers = this.headersPadrao
      }

      await axios.get(url).then((res) => {
        this.listaExportacaoInscricoes(res.data)
        this.inscritos = [];
        sessionStorage.setItem("Inscritos", JSON.stringify(res.data));
        for (var key in res.data) {
          res.data[key].dataHora = moment(res.data[key].created).format("DD/MM/YYYY HH:mm:ss"),
            res.data[key].checkin = res.data[key].checkin == null ? "" : this.formatDate(res.data[key].checkin.substr(0, 10)) + " " + res.data[key].checkin.substr(11, 8),
            res.data[key].participantes = this.exibeParticipantes(res.data[key].participantes),
            res.data[key].dataHoraPagamento = this.formatDateHora(res.data[key].dataHoraPagamento),
            res.data[key].validador = res.data[key].userValidatorCheckin == undefined ? "" : res.data[key].userValidatorCheckin.nome,
            res.data[key].divulgador = res.data[key].divulgador == undefined ? "" : res.data[key].divulgador.nome,
            res.data[key].vagas = res.data[key].vagas ? this.formatarLista(res.data[key].vagas, "vagas") : ""
        }

        this.inscritos = res.data
        this.isLoading = false;
        this.preparaImpressao(this.inscritos);
      });
    },

    exibeParticipantes(numero) {
      if (!numero) {
        return 1;
      } else {
        return numero;
      }
    },

    async realizaCheckin() {
      this.loading = true;
      await axios
        .post(
          `${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem(
            "accToken"
          )}`,
          this.checkin
        )
        .then((res) => {
          if (res.data != "") {
            switch (res.data.codigo) {
              case 3:
                //'Checkin confirmado
                this.loading = false;
                this.close();
                var vm = this;
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Checkin realizado com sucesso!",
                  "INFORMAÇÃO"
                );
                break;
              case 1:
                //'Checkin ja realizado'
                this.close();
                vm = this;
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Checkin já realizado!",
                  "INFORMAÇÃO"
                );
                this.loading = false;
                break;
              default:
                break;
            }
          } else {
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Erro ao realizar operação, tente novamente",
              "ERRO"
            );
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Erro ao realizar operação, tente novamente",
            "ERRO"
          );
        });
      await this.carregaInscritos();
      this.checkin.cod_incricao = "";
      this.checkin.tipo = "";
      this.checkin.eventoId = "";
      this.checkin.userValidatorId = "";
    },

    openDialog(item) {
      this.checkin.cod_incricao = item.cod_incricao;
      this.checkin.tipo = "CHECKIN";
      this.checkin.eventoId = undefined;
      this.checkin.empresaId = undefined;
      this.checkin.userValidatorId = this.user.id;
      this.nome = item.nome;

      if (this.companyobj.limiteInscricao == "SETOR") {
        this.checkin.empresaId = this.companyobj.id;
      } else {
        this.checkin.eventoId = this.eventoId;
      }

      this.dialog = true;
    },

    async editItem(item) {
      this.isLoading = true;
      this.editedIndex = this.inscritos.indexOf(item);
      try {
        await axios
          .get(
            `${baseApiUrl}inscricoes/${item.id
            }?access_token=${sessionStorage.getItem("accToken")}`
          )
          .then((response) => {
            if (response.data) {
              this.pegaImagem(response.data.id);
              this.editedItem.nome = response.data.nome;
              this.editedItem.cpf = response.data.cpf;
              this.editedItem.cnpj = response.data.cnpj;
              this.editItem.nomeCracha = response.data.nomeCracha;
              this.editedItem.cep = response.data.cep;
              this.editedItem.empresaNome = response.data.empresaNome;
              this.editedItem.cargo = response.data.cargo;
              this.editedItem.email = response.data.email;
              this.editedItem.email = response.data.email;
              this.editedItem.statusPagamento = response.data.statusPagamento;
              this.editedItem.id = response.data.id;
              this.editedItem.telefone = response.data.telefone;
              this.editedItem.cargo = response.data.cargo;
              this.editedItem.empresa = response.data.empresa;
              this.editedItem.nomeCracha = response.data.nomeCracha;
              this.editedItem.tipo = response.data.tipo;
              this.editedItem.sexo = response.data.sexo;
              this.editedItem.tamanhoCamisa = response.data.tamanhoCamisa;
              this.editedItem.celula = response.data.celula;
              this.editedItem.infoVacina = this.exibeInformacaoVacina(
                response.data.infoVacina
              );
              this.editedItem.formOfPayment = response.data.formOfPayment;
              this.editedItem.valorPago = response.data.valorPago;
              this.editedItem.codigoTransacao = response.data.codigoTransacao;
              this.editedItem.numero = response.data.numero;
              this.editedItem.participantes = response.data.participantes;
              this.editarInscricao = true;
              this.isLoading = false;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Problema encontrado ao editar inscrição",
          "DESCULPE"
        );
      }
    },

    async pegaImagem(idInscricao) {
      await axios
        .get(
          `${baseApiUrl}ImagesDocs?filter={"where":{"inscricaoId":"${idInscricao}"}}&access_token=${sessionStorage.getItem(
            "accToken"
          )}`
        )
        .then((response) => {
          if (response.data.length != 0) {
            this.editedItem.arquivoComprovanteVacinal =
              response.data[0].arquivoComprovanteVacinal;
          }
        });
    },

    exibeInformacaoVacina(informacao) {
      if (informacao == "1Dose") return "TOMOU A 1ª DOSE";
      if (informacao == "2Dose") return "TOMOU A 2ª DOSE";
      if (informacao == "3Dose") return "TOMOU A 3ª DOSE";
      if (informacao == "0Dose") return "NÃO VACINADO";
      if (informacao == "naoInformado") return "NÃO INFORMOU";
    },

    async sendEmail(item) {
      this.isLoading = true;
      this.editedItem.id = item.id;
      try {
        await axios
          .post(
            `${baseApiUrl}Inscricoes/EmailRecuperaAcesso?access_token=${sessionStorage.getItem(
              "accToken"
            )}`,
            { inscricaoId: this.editedItem.id }
          )
          .then((res) => {
            if (res.data) {
              this.isLoading = false;
              var vm = this;
              vm.$refs.chamaSnackbar.snack(
                "#0288D1",
                "E-mail enviado com sucesso!",
                "SUCESSO"
              );
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao enviar e-mail, tente novamente",
          "DESCULPE"
        );
      }
    },

    enviarNotificacao(item) {
      this.inscricaoId = item.id;
      this.dialogoNotificacao = true;
    },

    async enviaNotificacao(canal) {
      let vm = this;
      this.isLoading = true;

      await axios
        .post(
          baseApiUrl +
          "Notificacoes/inscricaoPaga?access_token" +
          sessionStorage.getItem("accToken"),
          { inscricaoId: this.inscricaoId, canal: canal }
        )
        .then((res) => {
          if (res.data) {
            this.inscricaoId = "";
            this.dialogoNotificacao = false;
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Notificação enviada!",
              "SUCESSO"
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao enviar notificação. " +
            error.response.data.error.message,
            "DESCULPE"
          );
        });
    },

    async consultarEvento() {
      await axios
        .get(
          baseApiUrl +
          "eventos/" +
          this.eventoId +
          "?access_token=" +
          sessionStorage.getItem("accToken")
        )
        .then((response) => {
          if (response.data) {
            this.dadosEvento = response.data;
          }
        });
    },

    async enviarCertificado(item) {
      let vm = this;
      this.isLoading = true;
      this.consultarEvento();

      await axios
        .post(
          baseApiUrl +
          "Notificacoes/noticacoesWhatsappEvento?access_token=" +
          sessionStorage.getItem("accToken"),
          {
            empresaId: this.empresaId,
            eventoId: this.eventoId,
            condicao: [{ cod_incricao: item.id }],
            tipo: this.dadosEvento.tipoNotificacaoCertificado,
            urlArquivo: this.dadosEvento.urlArquivoNotificacaoCertificado,
            mensagem: this.dadosEvento.mensagemNotificacaoCertificado,
          }
        )
        .then((res) => {
          if (res.data) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Certificado enviado!",
              "SUCESSO"
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao enviar certificado. " +
            error.response.data.error.message,
            "DESCULPE"
          );
        });
    },

    async deleteItem(item) {
      var r = confirm("Deseja realmente excluir: " + item.nome + " do Evento?");
      if (r == true) {
        this.isLoading = true;
        await axios
          .delete(
            `${baseApiUrl}Inscricoes/${item.id
            }?access_token=${sessionStorage.getItem("accToken")}`
          )
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Operação realizada com sucesso!",
              "INFORMAÇÃO"
            );
            this.eventoIdAtual = this.eventoId;
            this.carregaDados();
            //this.eventoId = this.eventoIdAtual
          })
          .catch(() => {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Erro ao realizar operação, tente novamente",
              "ERRO"
            );
          });
      }
    },

    close() {
      this.dialog = false;
      this.editarInscricao = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date;
    },

    formatarLista(lista, tipo) {
      let resultado = "";

      if (tipo == "filho") {
        lista.forEach((aluno, index) => {
          resultado += aluno.nome + " (" + aluno.turma + ")";

          if (index !== lista.length - 1) {
            resultado += ", ";
          }
        });
      }
      else if (tipo == "vagas") {
        lista.forEach((vaga, index) => {
          resultado += "Vaga:" + vaga.vaga + " - Setor:" + vaga.setor + "";

          if (index !== lista.length - 1) {
            resultado += ", ";
          }
        });
      }
      else if (tipo == "composicao") {
        lista.forEach((item, index) => {
          if (item.quantidade != "")
            resultado += item.tipo + " (" + item.quantidade + ")";

          if (index !== lista.length - 1 && item.quantidade != "") {
            resultado += " | ";
          }
        });
      }

      return resultado;
    },

    listaExportacaoInscricoes(lista) {
      this.listaExportacao = []

      for (let i = 0; i < lista.length; i++) {
        // Formata o valor pago como número para melhor visualização no Excel
        const valorPago = !isNaN(parseFloat(lista[i].valorPago)) ? 
          parseFloat(lista[i].valorPago).toFixed(2).replace('.', ',') : '';
        
        // Determina o status formatado com cores para melhor visualização
        let statusFormatado = lista[i].statusPagamento || '';
        
        this.listaExportacao.push({
          // Dados básicos da inscrição - informações mais importantes primeiro
          nome: lista[i].nome || '',
          cod_incricao: lista[i].cod_incricao || '',
          email: lista[i].email ? lista[i].email.toLowerCase() : '',
          telefone: lista[i].telefone || '',
          cpf: lista[i].cpf || '',
          sexo: lista[i].sexo || '',
          
          // Dados financeiros
          statusPagamento: statusFormatado,
          formOfPayment: lista[i].formOfPayment || '',
          valorPago: valorPago,
          
          // Datas importantes
          dataHora: moment(lista[i].created).format("DD/MM/YYYY HH:mm:ss"),
          dataHoraPagamento: this.formatDateHora(lista[i].dataHoraPagamento),
          checkin: lista[i].checkin == null
            ? ""
            : this.formatDate(lista[i].checkin.substr(0, 10)) +
              " " +
              lista[i].checkin.substr(11, 8),
          
          // Informações complementares
          lote: lista[i].lote || '',
          tamanhoCamisa: lista[i].tamanhoCamisa || '',
          setor: lista[i].setor || '',
          cargo: lista[i].cargo || '',
          empresaNome: lista[i].empresaNome || '',
          nomeCracha: lista[i].nomeCracha || '',
          participantes: this.exibeParticipantes(lista[i].participantes),
          
          // Informações de relacionamento
          divulgador: lista[i].divulgador == undefined ? "" : lista[i].divulgador.nome,
          validador: lista[i].userValidatorCheckin == undefined ? "" : lista[i].userValidatorCheckin.nome,
          
          // Detalhes estruturados
          composicao: lista[i].composicao
            ? this.formatarLista(lista[i].composicao, "composicao")
            : "",
          vagas: lista[i].vagas
            ? this.formatarLista(lista[i].vagas, "vagas")
            : "",
        });
      }
    },

    exportarParaCSV() {
      this.isLoading = true;
      
      try {
        // Obter colunas da tabela de headers
        const colunas = {};
        this.headers.forEach(header => {
          // Usar o text do header como nome de coluna e value como chave
          colunas[header.value] = header.text;
        });
        
        // Adicionar colunas extras que podem não estar visíveis na tabela
        const colunasExtras = {
          'dataHora': 'Data de Inscrição',
          'dataHoraPagamento': 'Data do Pagamento',
          'valorPago': 'Valor Pago (R$)',
          'statusPagamento': 'Status do Pagamento',
          'formOfPayment': 'Forma de Pagamento',
          'tamanhoCamisa': 'Tamanho da Camisa',
          'email': 'E-mail',
          'divulgador': 'Divulgador',
          'validador': 'Validador',
          'setor': 'Setor',
          'nomeCracha': 'Nome no Crachá',
          'empresaNome': 'Empresa',
          'cargo': 'Cargo',
          'lote': 'Lote',
          'composicao': 'Composição de Ingressos',
          'participantes': 'Participantes'
        };
        
        // Mesclar todas as colunas
        const todasColunas = { ...colunas, ...colunasExtras };
        
        // Preparar dados para exportação
        let dadosCSV = [];
        
        // Adicionar cabeçalho
        const cabecalhos = Object.values(todasColunas);
        dadosCSV.push(cabecalhos.join(';'));
        
        // Adicionar dados de cada inscrito
        this.inscritos.forEach(inscrito => {
          const linha = [];
          
          // Para cada coluna, obter o valor correspondente do inscrito
          Object.keys(todasColunas).forEach(coluna => {
            // Tratamentos especiais por tipo de campo
            let valor = inscrito[coluna];
            
            // Tratar campos numéricos para evitar formatação científica no Excel
            if (coluna === 'cod_incricao' && valor) {
              // Forçar o código de inscrição a ser tratado como texto adicionando aspas e um espaço no início
              valor = `="${valor}"`;
            } else if (coluna === 'cpf' && valor) {
              // Também tratar o CPF como texto para preservar zeros à esquerda
              valor = `="${valor}"`;
            } else if (coluna === 'telefone' && valor) {
              // Tratar telefone como texto
              valor = `="${valor}"`;
            } else if (coluna === 'valorPago' && valor !== undefined && valor !== null) {
              // Formatar valor monetário
              valor = typeof valor === 'number' ? 
                valor.toFixed(2).replace('.', ',') : 
                String(valor).replace('.', ',');
            } else if ((coluna === 'dataHora' || coluna === 'dataHoraPagamento' || coluna === 'checkin') && valor) {
              // Manter datas já formatadas
              valor = `="${valor}"`;
            } else if (coluna === 'divulgador' && inscrito.divulgador) {
              valor = inscrito.divulgador.nome || '';
            } else if (coluna === 'validador' && inscrito.userValidatorCheckin) {
              valor = inscrito.userValidatorCheckin.nome || '';
            } else if (coluna === 'composicao' && inscrito.composicao) {
              valor = this.formatarLista(inscrito.composicao, "composicao");
            } else if (coluna === 'vagas' && inscrito.vagas) {
              valor = this.formatarLista(inscrito.vagas, "vagas");
            }
            
            // Garantir que não há valores nulos ou undefined
            valor = valor !== undefined && valor !== null ? String(valor) : '';
            
            // Substituir ponto-e-vírgula por vírgula para não quebrar o CSV
            if (!valor.startsWith('="')) {
              valor = valor.replace(/;/g, ',');
            }
            
            linha.push(valor);
          });
          
          dadosCSV.push(linha.join(';'));
        });
        
        // Juntar todas as linhas com quebras de linha no estilo Windows (CR+LF)
        const conteudoCSV = dadosCSV.join('\r\n');
        
        // Adicionar BOM (Byte Order Mark) para indicar que é UTF-8
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const blob = new Blob([bom, conteudoCSV], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        
        // Criar URL temporária e configurar download
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `Inscritos_${this.eventoId}_${new Date().toISOString().slice(0,10)}.csv`);
        link.style.visibility = 'hidden';
        
        // Adicionar à página, clicar e remover
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.isLoading = false;
        this.$refs.chamaSnackbar.snack("#0288D1", "Relatório exportado com sucesso!", "SUCESSO");
      } catch (erro) {
        this.isLoading = false;
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao exportar relatório: " + erro.message, "ERRO");
      }
    },

    limparFiltroData() {
      this.dataInicioRaw = null;
      this.dataFimRaw = null;
      this.dataInicio = null;
      this.dataFim = null;
      this.filtroAtivo = false;
      
      // Restaurar lista original
      if (this.inscritosSemFiltroData.length > 0) {
        this.inscritos = [...this.inscritosSemFiltroData];
        this.inscritosSemFiltroData = [];
      }
      
      this.showFilterMenu = false;
      
      this.$refs.chamaSnackbar.snack(
        "#0288D1",
        "Filtro por data removido",
        "INFORMAÇÃO"
      );
    },

    aplicarFiltroData() {
      if (!this.dataInicioRaw || !this.dataFimRaw) {
        this.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Por favor, selecione as datas inicial e final",
          "AVISO"
        );
        return;
      }

      this.dataInicio = this.formatDateBrz(this.dataInicioRaw);
      this.dataFim = this.formatDateBrz(this.dataFimRaw);
      
      // Se for o primeiro filtro, guarda a lista completa
      if (!this.filtroAtivo) {
        this.inscritosSemFiltroData = [...this.inscritos];
      }
      
      this.filtroAtivo = true;
      this.filtrarInscritosPorData();
      this.showFilterMenu = false;
    },
    
    filtrarInscritosPorData() {
      if (!this.filtroAtivo || !this.dataInicioRaw || !this.dataFimRaw) {
        return;
      }
      
      const dataInicio = moment(this.dataInicioRaw).startOf('day');
      const dataFim = moment(this.dataFimRaw).endOf('day');
      
      // Lista original ou atual
      const listaParaFiltrar = this.inscritosSemFiltroData.length > 0 
        ? this.inscritosSemFiltroData 
        : this.inscritos;
      
      this.inscritos = listaParaFiltrar.filter(item => {
        let dataItem;
        
        if (this.filtroTipo === 'cadastro') {
          dataItem = moment(item.created);
        } else if (this.filtroTipo === 'pagamento') {
          // Verificando se tem data de pagamento antes de tentar converter
          if (!item.dataHoraPagamento) return false;
          
          // Converte do formato DD/MM/YYYY HH:mm:ss para um objeto moment
          dataItem = moment(item.dataHoraPagamento, 'DD/MM/YYYY HH:mm:ss');
        }
        
        return dataItem.isBetween(dataInicio, dataFim, null, '[]');
      });
      
      // Mensagem de resultado
      this.$refs.chamaSnackbar.snack(
        "#0288D1",
        `Filtro aplicado: ${this.inscritos.length} inscrições encontradas`,
        "INFORMAÇÃO"
      );
    },
  },
};
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253e;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url("https://fonts.google.com/specimen/Roboto");
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
